import { chakra, Flex, IconButton, Icon, HTMLChakraProps } from '@chakra-ui/react';
import { FC, useState } from 'react';
import TextareaAutosize from 'react-textarea-autosize';

import SendIcon from '@/assets/icons/ic-send-message.svg';

const AutoResizeInput = chakra(TextareaAutosize);

interface IMessageInputProps extends HTMLChakraProps<'div'> {
  placeholder: string;
  isSubmitting?: boolean;
  onSend: (message: string) => Promise<void>;
}

export const MessageInput: FC<IMessageInputProps> = ({ placeholder, isSubmitting, onSend, ...rest }) => {
  const [text, setText] = useState('');

  const onFormSubmit = async () => {
    if (text.trim() !== '') {
      await onSend(text);
      setText('');
    }
  };

  const onSendClick = (event) => {
    event.preventDefault();
    onFormSubmit();
  };

  const onKeyDown = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      onFormSubmit();
      event.preventDefault();
    }
  };

  return (
    <Flex
      w="full"
      alignItems="center"
      border="1px"
      borderColor="gray.200"
      borderRadius="4px"
      autoComplete="off"
      px={1}
      py="3px"
      {...rest}
    >
      <AutoResizeInput
        resize="none"
        w="full"
        outline="none"
        borderRadius="4px"
        px={4}
        py={2}
        value={text}
        placeholder={placeholder}
        maxRows={7}
        onKeyDown={onKeyDown}
        onChange={(ev) => setText(ev.target.value)}
        disabled={isSubmitting}
      />
      {text && (
        <IconButton
          aria-label="Send"
          variant="ghost"
          size="md"
          alignSelf="flex-end"
          onClick={onSendClick}
          isLoading={isSubmitting}
        >
          <Icon w="24px" h="24px" as={SendIcon} />
        </IconButton>
      )}
    </Flex>
  );
};
